/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-28 09:22:48 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 14:06:07
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Brand Referral Bonus</h1>
      <h2>What is the Brand Referral Bonus (BRB)?</h2>
      <p>
        The Brand Referral Bonus (BRB) is an approximate 10% credit on sales
        from external traffic that you bring to Amazon, as long as the traffic
        is properly tagged with Amazon Attribution. The bonus is paid directly
        to sellers.
      </p>
      <h2>How do I enroll in the Brand Referral Bonus program?</h2>
      <p>Enrolling in BRB is free and easy. Just follow these steps:</p>
      <ol>
        <li>Log in to your <b class="fw600">Seller Central account</b></li>
        <li>Navigate to the <b class="fw600">Brands tab</b></li>
        <li>Find the <b class="fw600">Brand Referral Bonus</b> option and click on it</li>
        <li>On the Brand Referral Bonus page, click <b class="fw600">Enroll Now</b></li>
        <li>The enrollment process usually takes just a few minutes</li>
      </ol>
      <p>
        Once enrolled, you can start earning bonus credits from your external
        marketing efforts!
      </p>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>